import React from "react";
import { PageClean } from "..";
import { Row, Col } from "@intechprev/componentes-web";
import { UsuarioService } from "../../services";
import { Session } from "@intech/react-service";
import { reCAPTCHA } from "../../helpers";

interface Props {
  history?: any;
}

interface State {
  matriculas: Array<string>;
}

export class SelecionarMatricula extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("selecionar_matricula");

  state: State = {
    matriculas: [],
  };

  componentDidMount = async () => {
    try {
      const matriculas = await UsuarioService.BuscarMatriculas();

      await this.setState({
        matriculas,
      });
    } catch (err) {
      console.log(err);
    }
  };

  selecionar = async (matricula: string) => {
    var funcionarioLogin = await UsuarioService.SelecionarMatricula({ Matricula: matricula, Origem: 1 });

    await Session.setToken(funcionarioLogin.AccessToken);

    this.props.history.push("/");
  };

  render() {
    return (
      <PageClean {...this.props}>
        <h4>Bem vindo ao portal da PREVIRB</h4>

        <h5>
          <b>Área de Acesso Restrito</b>
          <br />
          <small>
            Para informações, entre em contato com a{" "}
            <a target="_blank" href="https://www.previrb.com.br/fale-conosco/" rel="noopener noreferrer">
              PREVIRB
            </a>
          </small>
          <br />
          <br />
        </h5>

        <form>
          <h5 className={"mb-3"}>
            <b>Selecione uma matrícula:</b>
          </h5>

          {this.state.matriculas.map((matricula, index) => {
            return (
              <Row key={index} className={"mb-3"}>
                <Col>
                  <div className="matricula-card" onClick={() => this.selecionar(matricula)}>
                    <Row>
                      <Col>
                        <b>Matrícula: </b>
                        <label style={{ fontSize: 15 }}>{matricula}</label>
                        <br />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            );
          })}
        </form>
      </PageClean>
    );
  }
}
